(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kb-bestsellers"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var mq = window.matchMedia('(min-width: 1024px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var LERP = 0.12; // smoothing factor - lower = silkier, higher = snappier

    function init(section) {
      var track = section.querySelector('[data-bestsellers-track]');
      if (!track) return;

      var targetX = 0;
      var currentX = 0;
      var overflow = 0;
      var rafId = 0;
      var running = false;

      function reset() {
        section.style.minHeight = '';
        targetX = 0;
        currentX = 0;
        track.style.setProperty('--kb-track-x', '0px');
      }

      /* `range` is cached here rather than re-read in readTarget(). It only
         changes when the viewport or track width changes, and reading
         section.offsetHeight on every scroll - right after measure() writes
         section.style.minHeight - forced a synchronous layout each frame. */
      var range = 0;

      function measure() {
        if (!mq.matches || reduce.matches) { reset(); range = 0; return 0; }
        var o = Math.max(0, track.scrollWidth - track.clientWidth);
        if (o <= 0) { reset(); range = 0; return 0; }
        var vh = window.innerHeight;
        section.style.minHeight = (vh + o) + 'px';
        // minHeight was just set to vh + o, so offsetHeight would return that
        // same value - compute it instead of reading it back.
        range = o;
        return o;
      }

      function readTarget() {
        if (!mq.matches || reduce.matches || overflow <= 0 || range <= 0) { targetX = 0; return; }
        var rect = section.getBoundingClientRect();
        var scrolled = Math.max(0, Math.min(range, -rect.top));
        var progress = scrolled / range;
        targetX = -overflow * progress;
      }

      function tick() {
        var delta = targetX - currentX;
        if (Math.abs(delta) < 0.15) {
          currentX = targetX;
          track.style.setProperty('--kb-track-x', currentX + 'px');
          running = false;
          return;
        }
        currentX += delta * LERP;
        track.style.setProperty('--kb-track-x', currentX + 'px');
        rafId = requestAnimationFrame(tick);
      }

      function kick() {
        readTarget();
        if (!running) {
          running = true;
          rafId = requestAnimationFrame(tick);
        }
      }

      function onScroll() { kick(); }
      function onResize() {
        overflow = measure();
        // Snap on resize to avoid visible drift
        readTarget();
        currentX = targetX;
        track.style.setProperty('--kb-track-x', currentX + 'px');
      }

      overflow = measure();
      readTarget();
      currentX = targetX;
      track.style.setProperty('--kb-track-x', currentX + 'px');

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize);
      mq.addEventListener ? mq.addEventListener('change', onResize) : mq.addListener(onResize);

      var imgs = track.querySelectorAll('img');
      var pending = imgs.length;
      if (pending) {
        for (var i = 0; i < imgs.length; i++) {
          if (imgs[i].complete) { if (--pending === 0) onResize(); }
          else imgs[i].addEventListener('load', function() { if (--pending === 0) onResize(); }, { once: true });
        }
      }
    }

    /* This is a scroll effect for content well below the fold, and init()
       measures layout (scrollWidth/clientWidth), so running it during parse
       forced a synchronous layout before first paint. Deferred to idle time. */
    function start() {
      var sections = document.querySelectorAll('.kb-bestsellers--pinned');
      for (var i = 0; i < sections.length; i++) init(sections[i]);
    }

    if ('requestIdleCallback' in window) {
      requestIdleCallback(start, { timeout: 2000 });
    } else {
      setTimeout(start, 200);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function initFilters(panel) {
      var section = panel.closest('.kb-collection');
      if (!section) return;
      var items = Array.prototype.slice.call(section.querySelectorAll('[data-kb-filter-item]'));
      var gender = panel.querySelector('[data-kb-filter="gender"]');
      var interest = panel.querySelector('[data-kb-filter="interest"]');
      var genderSwitchesCollection = Boolean(gender && gender.hasAttribute('data-kb-gender-nav'));
      var clearButtons = section.querySelectorAll('[data-kb-filter-clear]');
      var count = panel.querySelector('[data-kb-filter-count]');
      var countNum = panel.querySelector('[data-kb-count-num]');
      var countWord = panel.querySelector('[data-kb-count-word]');
      var selects = [gender, interest].filter(Boolean);
      var search = panel.querySelector('[data-kb-filter-search]');
      var searchPill = panel.querySelector('[data-kb-search-pill]');
      var searchReset = panel.querySelector('[data-kb-search-reset]');
      var empty = section.querySelector('[data-kb-filter-empty]');
      var pagination = section.querySelector('.kb-collection__pagination');
      var grid = section.querySelector('.kb-collection__grid');

      // Lowercase and drop accents, so "chloe" finds "Chloé".
      function normalize(text) {
        text = String(text || '').toLowerCase();
        if (text.normalize) text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        return text.replace(/\s+/g, ' ').trim();
      }

      var searchTexts = items.map(function (item) {
        return normalize(item.getAttribute('data-search'));
      });

      // Every word typed has to appear somewhere in the book's text.
      function searchWords() {
        var q = search ? normalize(search.value) : '';
        return q ? q.split(' ') : [];
      }

      function pick(select, value) {
        if (!select || !value) return;
        for (var i = 0; i < select.options.length; i++) {
          if (select.options[i].value === value) {
            select.value = value;
            return;
          }
        }
      }

      function activeGender() {
        // On the boys/girls collections the select names the collection
        // itself, so it never counts as a filter.
        if (!gender || genderSwitchesCollection) return '';
        return gender.value;
      }

      function apply(updateUrl) {
        var g = activeGender();
        var t = interest ? interest.value : '';
        var words = searchWords();
        var active = Boolean(g || t || words.length);
        var shown = 0;

        items.forEach(function (item, index) {
          var genders = item.getAttribute('data-gender');
          var genderOk = !g || !genders || genders.split(' ').indexOf(g) !== -1;
          var interestOk = !t || item.getAttribute('data-interest') === t;
          var searchOk = words.every(function (word) {
            return searchTexts[index].indexOf(word) !== -1;
          });
          var visible = genderOk && interestOk && searchOk;
          var wasHidden = item.hidden;
          item.hidden = !visible;
          item.classList.remove('kb-collection__item--enter');
          if (visible) {
            shown++;
            if (updateUrl && wasHidden && !reduceMotion) {
              // Restart the entry animation for books that just came back.
              void item.offsetWidth;
              item.classList.add('kb-collection__item--enter');
            }
          }
        });

        countNum.textContent = shown;
        countWord.textContent = shown === 1 ? count.getAttribute('data-one') : count.getAttribute('data-other');
        if (empty) empty.hidden = shown > 0;
        if (pagination) pagination.hidden = active;
        grid.classList.toggle('kb-collection__grid--filtered', active);
        clearButtons[0].disabled = !active;

        if (updateUrl && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          if (g) url.searchParams.set('gender', g); else url.searchParams.delete('gender');
          if (t) url.searchParams.set('interest', t); else url.searchParams.delete('interest');
          var q = search ? search.value.trim() : '';
          if (q) url.searchParams.set('q', q); else url.searchParams.delete('q');
          window.history.replaceState(window.history.state, '', url.toString());
        }
      }

      // Mirror each select's choice onto its pill.
      function sync(select) {
        var pill = select.closest('[data-kb-pill]');
        var option = select.options[select.selectedIndex];
        pill.querySelector('[data-kb-pill-value]').textContent = option ? option.text : '';
        pill.classList.toggle('is-set', select.value !== '');
      }

      function syncSearch() {
        if (!search) return;
        var hasText = search.value !== '';
        searchPill.classList.toggle('is-set', hasText);
        searchReset.hidden = !hasText;
      }

      function syncAll() {
        selects.forEach(sync);
        syncSearch();
      }

      function switchCollection() {
        var option = gender.options[gender.selectedIndex];
        var href = option && option.getAttribute('data-href');
        if (!href) return;
        var url = new URL(href, window.location.origin);
        if (interest && interest.value) url.searchParams.set('interest', interest.value);
        if (search && search.value.trim()) url.searchParams.set('q', search.value.trim());
        window.location.assign(url.toString());
      }

      var params = new URLSearchParams(window.location.search);
      if (!genderSwitchesCollection) pick(gender, params.get('gender'));
      pick(interest, params.get('interest'));
      if (search && params.get('q')) search.value = params.get('q');

      if (gender) {
        gender.addEventListener('change', function () {
          sync(gender);
          if (genderSwitchesCollection) switchCollection();
          else apply(true);
        });
      }
      if (interest) {
        interest.addEventListener('change', function () {
          sync(interest);
          apply(true);
        });
      }

      if (search) {
        search.addEventListener('input', function () {
          syncSearch();
          apply(true);
        });
        search.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && search.value) {
            event.preventDefault();
            search.value = '';
            syncSearch();
            apply(true);
          } else if (event.key === 'Enter') {
            // Close the phone keyboard so the results are in view.
            search.blur();
          }
        });
        searchReset.addEventListener('click', function () {
          search.value = '';
          syncSearch();
          apply(true);
          search.focus();
        });
        searchPill.addEventListener('click', function (event) {
          if (event.target === searchPill) search.focus();
        });
      }

      Array.prototype.forEach.call(clearButtons, function (button) {
        button.addEventListener('click', function () {
          if (gender && !genderSwitchesCollection) gender.value = '';
          if (interest) interest.value = '';
          if (search) search.value = '';
          syncAll();
          apply(true);
          (search || interest || gender).focus();
        });
      });

      // Back/forward cache can restore a page whose select still shows the
      // collection the shopper switched to; reset it to this collection.
      window.addEventListener('pageshow', function (event) {
        if (event.persisted && genderSwitchesCollection) {
          for (var i = 0; i < gender.options.length; i++) {
            if (gender.options[i].defaultSelected) gender.selectedIndex = i;
          }
          sync(gender);
        }
      });

      panel.hidden = false;
      syncAll();
      apply(false);
    }

    function boot() {
      document.querySelectorAll('[data-kb-filters]').forEach(initFilters);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-cta-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MOBILE_BREAKPOINT = 820;
    var viewports = document.querySelectorAll('[data-kb-ctaf-viewport]');
    if (!viewports.length) return;

    viewports.forEach(function (viewport) {
      viewport.tabIndex = 0;

      viewport.addEventListener('scroll', function () {
        if (window.innerWidth <= MOBILE_BREAKPOINT && viewport.scrollLeft > 4) {
          viewport.dataset.explored = '';
        }
      }, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-how-it-works"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var mq = window.matchMedia('(min-width: 1024px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var LERP = 0.14;

    function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
    function easeOut(t) { return 1 - Math.pow(1 - t, 3); } // cubic ease-out for a premium feel

    function init(section) {
      var steps = section.querySelectorAll('.kb-howit__step--reveal');
      if (!steps.length) return;
      var n = steps.length;

      var targets = new Float32Array(n);
      var currents = new Float32Array(n);
      var running = false;

      function setAll(v) {
        for (var i = 0; i < n; i++) {
          currents[i] = targets[i] = v;
          steps[i].style.setProperty('--kb-step-p', v);
        }
      }

      if (reduce.matches || !mq.matches) {
        setAll(1);
        return;
      }

      function readTargets() {
        var rect = section.getBoundingClientRect();
        var range = section.offsetHeight - window.innerHeight;
        if (range <= 0) { for (var i = 0; i < n; i++) targets[i] = 1; return; }
        var scrolled = Math.max(0, Math.min(range, -rect.top));
        var progress = scrolled / range;
        // Each step gets its own sub-range of the overall progress.
        // Window of ~ 1/n with smooth ramp.
        var span = 1 / n;
        for (var i = 0; i < n; i++) {
          var start = i * span * 0.85; // slight overlap between steps
          var local = clamp01((progress - start) / span);
          targets[i] = easeOut(local);
        }
      }

      function tick() {
        var stillMoving = false;
        for (var i = 0; i < n; i++) {
          var d = targets[i] - currents[i];
          if (Math.abs(d) < 0.001) {
            currents[i] = targets[i];
          } else {
            currents[i] += d * LERP;
            stillMoving = true;
          }
          steps[i].style.setProperty('--kb-step-p', currents[i].toFixed(4));
        }
        if (stillMoving) requestAnimationFrame(tick);
        else running = false;
      }

      function kick() {
        readTargets();
        if (!running) { running = true; requestAnimationFrame(tick); }
      }

      function onScroll() { kick(); }
      function onResize() {
        if (!mq.matches || reduce.matches) { setAll(1); return; }
        readTargets();
        for (var i = 0; i < n; i++) {
          currents[i] = targets[i];
          steps[i].style.setProperty('--kb-step-p', currents[i]);
        }
      }

      readTargets();
      for (var i = 0; i < n; i++) {
        currents[i] = targets[i];
        steps[i].style.setProperty('--kb-step-p', currents[i]);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize);
      mq.addEventListener ? mq.addEventListener('change', onResize) : mq.addListener(onResize);
    }

    var sections = document.querySelectorAll('.kb-howit--pinned');
    for (var i = 0; i < sections.length; i++) init(sections[i]);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-landing-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var comparators = document.querySelectorAll('[data-kb-hcompare]');
    comparators.forEach(function (root) {
      var clip    = root.querySelector('[data-kb-hcompare-clip]');
      var divider = root.querySelector('[data-kb-hcompare-divider]');
      var frame   = root.querySelector('[data-kb-hcompare-frame]');
      if (!clip || !divider || !frame) return;

      // Paint-only: one custom property drives clip-path + transform.
      function setPosition(percent) {
        percent = Math.max(0, Math.min(100, percent));
        root.style.setProperty('--kb-pos', percent.toFixed(2) + '%');
        root.setAttribute('aria-valuenow', Math.round(percent));
      }

      // The frame's box is read once when a drag starts, not on every move.
      var rect = null;
      function fromClientX(clientX) {
        if (!rect) rect = frame.getBoundingClientRect();
        return ((clientX - rect.left) / rect.width) * 100;
      }

      var dragging = false;

      function startDrag(e, allowNativeScroll) {
        rect = frame.getBoundingClientRect();
        dragging = true;
        root.setAttribute('data-active', 'true');
        // Only block defaults for mouse (image drag / text selection).
        // Touch stays passive so touch-action: pan-y lets the page scroll.
        if (!allowNativeScroll && e.cancelable) e.preventDefault();
      }
      function stopDrag() {
        if (!dragging) return;
        dragging = false;
        root.setAttribute('data-active', 'false');
      }
      function onMove(e) {
        if (!dragging) return;
        var clientX = e.touches ? e.touches[0].clientX : e.clientX;
        setPosition(fromClientX(clientX));
      }

      root.addEventListener('mousedown', function (e) {
        startDrag(e);
        setPosition(fromClientX(e.clientX));
      });
      root.addEventListener('touchstart', function (e) {
        startDrag(e, true);
        setPosition(fromClientX(e.touches[0].clientX));
      }, { passive: true });

      window.addEventListener('mousemove', onMove);
      window.addEventListener('touchmove', onMove, { passive: true });
      window.addEventListener('mouseup', stopDrag);
      window.addEventListener('touchend', stopDrag);
      window.addEventListener('touchcancel', stopDrag);

      root.addEventListener('keydown', function (e) {
        var current = parseFloat(root.getAttribute('aria-valuenow')) || 50;
        var step = e.shiftKey ? 10 : 4;
        if (e.key === 'ArrowLeft')  { setPosition(current - step); e.preventDefault(); }
        if (e.key === 'ArrowRight') { setPosition(current + step); e.preventDefault(); }
        if (e.key === 'Home')       { setPosition(0); e.preventDefault(); }
        if (e.key === 'End')        { setPosition(100); e.preventDefault(); }
      });

      setPosition(50);

      // One-time nudge when the slider first scrolls into view: the handle
      // sweeps a little each way and settles back, so a first-time visitor
      // sees that it moves without being told. Cancelled the moment they
      // touch it; skipped under reduced motion.
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reduced && 'IntersectionObserver' in window) {
        var nudged = false;
        var io = new IntersectionObserver(function (entries) {
          if (nudged || !entries[0].isIntersecting) return;
          nudged = true;
          io.disconnect();
          var start = null, dur = 1800;
          function frameFn(ts) {
            if (dragging) return;
            if (!start) start = ts;
            var t = Math.min(1, (ts - start) / dur);
            // ease-in-out sine wave: 50 → 62 → 38 → 50
            var p = 50 + Math.sin(t * Math.PI * 2) * 12 * Math.sin(t * Math.PI);
            setPosition(p);
            if (t < 1) requestAnimationFrame(frameFn);
          }
          setTimeout(function () { requestAnimationFrame(frameFn); }, 600);
        }, { threshold: 0.6 });
        io.observe(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-landing-picker"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var picker = document.querySelector('[data-kb-picker]');
    if (!picker) return;

    var label = document.querySelector('[data-kb-picker-selected]');
    var uploader = document.querySelector('[data-kb-upload]');
    var nudge = document.querySelector('[data-kb-picker-nudge]');
    var nudgeTitle = document.querySelector('[data-kb-picker-nudge-title]');

    // Visible reward for a real choice: a hop, a star burst from the cover,
    // and a nudge toward the uploader.
    function celebrate(input) {
      var card = input.closest('.kb-landing-picker__card');
      if (!card) return;
      picker.querySelectorAll('.kb-landing-picker__card.is-picked').forEach(function (c) { c.classList.remove('is-picked'); });
      void card.offsetWidth;
      card.classList.add('is-picked');
      var cover = card.querySelector('.kb-landing-picker__cover');
      if (cover && window.kbBurst) {
        var r = cover.getBoundingClientRect();
        window.kbBurst(r.left + r.width / 2, r.top + r.height * 0.4, 14);
      }
      if (nudge) {
        if (nudgeTitle) nudgeTitle.textContent = (input.getAttribute('data-title') || '').split(':')[0].trim();
        nudge.hidden = false;
      }
    }

    function announce(input, scroll) {
      var detail = {
        handle: input.value,
        title: input.getAttribute('data-title') || '',
        price: input.getAttribute('data-price') || '',
        available: input.getAttribute('data-available') === 'true',
        url: input.getAttribute('data-url') || '',
        cover: input.getAttribute('data-cover') || '',
        fromPrice: input.getAttribute('data-from-price') || ''
      };
      if (label) label.textContent = detail.title.split(':')[0].trim();
      document.dispatchEvent(new CustomEvent('kb:book-change', { detail: detail }));

      // On a phone the uploader is below the fold; bring it up so the next
      // step is obvious without hunting for it.
      if (scroll && uploader && window.innerWidth < 861) {
        var card = uploader.closest('.kb-start-personalising__panel') || uploader;
        try { card.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { card.scrollIntoView(); }
      }
    }

    picker.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || input.name !== 'kb-landing-pick') return;
      celebrate(input);
      announce(input, true);
    });

    // The editor's pre-selected book may not be among the cards shown (it is
    // limited to the first N of the collection) - fall back to the first card
    // so there is always a selection and the uploader always has a book.
    var initial = picker.querySelector('input[name="kb-landing-pick"]:checked')
      || picker.querySelector('input[name="kb-landing-pick"]');
    if (initial) { initial.checked = true; announce(initial, false); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-photo-to-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var comparators = document.querySelectorAll('[data-kb-compare]');
    comparators.forEach(function (root) {
      var clip    = root.querySelector('[data-kb-compare-clip]');
      var divider = root.querySelector('[data-kb-compare-divider]');
      var handle  = root.querySelector('[data-kb-compare-handle]');
      var frame   = root.querySelector('.kb-compare__frame');
      if (!clip || !divider || !frame) return;

      // Paint-only: one custom property drives clip-path + transform.
      function setPosition(percent) {
        percent = Math.max(0, Math.min(100, percent));
        root.style.setProperty('--kb-pos', percent.toFixed(2) + '%');
        root.setAttribute('aria-valuenow', Math.round(percent));
      }

      // The frame's box is read once when a drag starts, not on every move.
      var rect = null;
      function fromClientX(clientX) {
        if (!rect) rect = frame.getBoundingClientRect();
        return ((clientX - rect.left) / rect.width) * 100;
      }

      var dragging = false;

      function startDrag(e, allowNativeScroll) {
        rect = frame.getBoundingClientRect();
        dragging = true;
        root.setAttribute('data-active', 'true');
        // Only block defaults for mouse (image drag / text selection).
        // Touch stays passive so touch-action: pan-y lets the page scroll.
        if (!allowNativeScroll && e.cancelable) e.preventDefault();
      }
      function stopDrag() {
        if (!dragging) return;
        dragging = false;
        root.setAttribute('data-active', 'false');
      }
      function onMove(e) {
        if (!dragging) return;
        var clientX = e.touches ? e.touches[0].clientX : e.clientX;
        setPosition(fromClientX(clientX));
      }

      // Pointer drag from anywhere inside the frame.
      root.addEventListener('mousedown', function (e) {
        startDrag(e);
        setPosition(fromClientX(e.clientX));
      });
      root.addEventListener('touchstart', function (e) {
        startDrag(e, true);
        setPosition(fromClientX(e.touches[0].clientX));
      }, { passive: true });

      window.addEventListener('mousemove', onMove);
      window.addEventListener('touchmove', onMove, { passive: true });
      window.addEventListener('mouseup', stopDrag);
      window.addEventListener('touchend', stopDrag);
      window.addEventListener('touchcancel', stopDrag);

      // Keyboard support for the slider role.
      root.addEventListener('keydown', function (e) {
        var current = parseFloat(root.getAttribute('aria-valuenow')) || 50;
        var step = e.shiftKey ? 10 : 4;
        if (e.key === 'ArrowLeft')  { setPosition(current - step); e.preventDefault(); }
        if (e.key === 'ArrowRight') { setPosition(current + step); e.preventDefault(); }
        if (e.key === 'Home')       { setPosition(0); e.preventDefault(); }
        if (e.key === 'End')        { setPosition(100); e.preventDefault(); }
      });

      // Initial state (CSS already defaults --kb-pos to 50%).
      setPosition(50);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-product-detail"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var galleries = document.querySelectorAll('[data-kb-gallery]');
    galleries.forEach(function (root) {
      var slides = root.querySelectorAll('[data-kb-slide]');
      var thumbs = root.querySelectorAll('[data-kb-thumb]');
      var dots   = root.querySelectorAll('[data-kb-dot]');
      var prev   = root.querySelector('[data-kb-prev]');
      var next   = root.querySelector('[data-kb-next]');
      if (slides.length <= 1) return;

      var current = 0;

      /* Slides after the first ship without src/srcset so they cannot compete
         with the LCP image on first paint. Move the real URLs into place the
         moment a slide is needed. Idempotent: the data attributes are removed
         once used. */
      function hydrate(slide) {
        if (!slide) return;
        var imgs = slide.querySelectorAll('img[data-kb-slide-src]');
        for (var i = 0; i < imgs.length; i++) {
          var img = imgs[i];
          var srcset = img.getAttribute('data-kb-slide-srcset');
          if (srcset) img.setAttribute('srcset', srcset);
          img.setAttribute('src', img.getAttribute('data-kb-slide-src'));
          img.removeAttribute('data-kb-slide-src');
          img.removeAttribute('data-kb-slide-srcset');
        }
      }

      /* Warm the slide the visitor is most likely to open next, but only after
         the page has gone quiet so it never steals bandwidth from the LCP. */
      function warmNeighbour(index) {
        var after = slides[(index + 1) % slides.length];
        var run = function () { hydrate(after); };
        if ('requestIdleCallback' in window) {
          requestIdleCallback(run, { timeout: 2000 });
        } else {
          setTimeout(run, 1200);
        }
      }

      function setActive(index) {
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;
        current = index;

        hydrate(slides[index]);
        warmNeighbour(index);

        slides.forEach(function (slide, i) {
          var isActive = i === index;
          slide.classList.toggle('is-active', isActive);
          if (isActive) {
            slide.removeAttribute('aria-hidden');
          } else {
            slide.setAttribute('aria-hidden', 'true');
          }
        });

        thumbs.forEach(function (thumb, i) {
          var isActive = i === index;
          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        dots.forEach(function (dot, i) {
          var isActive = i === index;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          setActive(parseInt(thumb.dataset.index, 10) || 0);
        });
      });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          setActive(parseInt(dot.dataset.index, 10) || 0);
        });
      });

      if (prev) prev.addEventListener('click', function () { setActive(current - 1); });
      if (next) next.addEventListener('click', function () { setActive(current + 1); });

      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft')  { setActive(current - 1); }
        if (e.key === 'ArrowRight') { setActive(current + 1); }
      });

      /* Slide 1 is already marked active by Liquid, so setActive() has not run
         yet - warm its neighbour here so the first tap on "next" is instant. */
      warmNeighbour(0);
    });

    // ---------- FAQ accordion (smooth open/close) ----------
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-kb-faq-details]').forEach(function (details) {
      var summary = details.querySelector('summary');
      var answer  = details.querySelector('[data-kb-faq-answer]');
      if (!summary || !answer) return;

      // Initialise closed state height (open items left fully expanded).
      if (!details.open) {
        answer.style.maxHeight = '0px';
      } else {
        answer.style.maxHeight = 'none';
      }

      function expand() {
        details.open = true;
        if (reduceMotion) {
          answer.style.maxHeight = 'none';
          return;
        }
        answer.style.maxHeight = '0px';
        // Force reflow so the transition picks up the change.
        void answer.offsetHeight;
        answer.style.maxHeight = answer.scrollHeight + 'px';

        var onEnd = function (e) {
          if (e.propertyName !== 'max-height') return;
          answer.removeEventListener('transitionend', onEnd);
          if (details.open) answer.style.maxHeight = 'none';
        };
        answer.addEventListener('transitionend', onEnd);
      }

      function collapse() {
        if (reduceMotion) {
          details.open = false;
          answer.style.maxHeight = '0px';
          return;
        }
        // Lock current height so we can transition from a known value.
        answer.style.maxHeight = answer.scrollHeight + 'px';
        void answer.offsetHeight;
        answer.style.maxHeight = '0px';

        var onEnd = function (e) {
          if (e.propertyName !== 'max-height') return;
          answer.removeEventListener('transitionend', onEnd);
          details.open = false;
        };
        answer.addEventListener('transitionend', onEnd);
      }

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (details.open) {
          collapse();
        } else {
          expand();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-promo-bar"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var INTERVAL = 4500;

    function init(list) {
      if (!list || list.dataset.kbPromoReady) return;
      list.dataset.kbPromoReady = 'true';
      var items = list.querySelectorAll('[data-kb-promo-item]');
      if (items.length < 2) return;

      var index = 0;
      var paused = false;

      /* The outgoing message exits left, then resets to the right edge while hidden. */
      function show(i) {
        var prev = items[index];
        index = (i + items.length) % items.length;
        if (prev === items[index]) return;
        prev.classList.remove('is-active');
        prev.classList.add('is-leaving');
        setTimeout(function() { prev.classList.remove('is-leaving'); }, 650);
        items[index].classList.remove('is-leaving');
        items[index].classList.add('is-active');
      }

      setInterval(function() {
        if (!paused && !document.hidden) show(index + 1);
      }, INTERVAL);

      list.addEventListener('mouseenter', function() { paused = true; });
      list.addEventListener('mouseleave', function() { paused = false; });

      /* Theme editor: jump to the selected message and hold it there. */
      document.addEventListener('shopify:block:select', function(e) {
        var i = Array.prototype.indexOf.call(items, e.target);
        if (i < 0) return;
        paused = true;
        show(i);
      });
      document.addEventListener('shopify:block:deselect', function() { paused = false; });
    }

    function initAll() {
      document.querySelectorAll('[data-kb-promo]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-reactions"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var carousels = document.querySelectorAll('[data-kb-carousel]');
    carousels.forEach(function (root) {
      var track = root.querySelector('[data-kb-carousel-track]');
      var slides = root.querySelectorAll('[data-kb-carousel-slide]');
      var prevBtn = root.querySelector('[data-kb-carousel-prev]');
      var nextBtn = root.querySelector('[data-kb-carousel-next]');
      var dots = root.querySelectorAll('[data-kb-carousel-dot]');

      if (!track || slides.length <= 1) return;

      var current = 0;
      var slideWidth = 0;

      function measure() {
        slideWidth = slides[0].getBoundingClientRect().width + 16; // 16 = gap
      }

      function scrollTo(index) {
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;
        current = index;
        track.scrollLeft = index * slideWidth;

        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }

      measure();
      var ro = new ResizeObserver(measure);
      ro.observe(track);

      if (prevBtn) prevBtn.addEventListener('click', function () { scrollTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollTo(current + 1); });

      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () { scrollTo(index); });
      });

      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft')  { scrollTo(current - 1); e.preventDefault(); }
        if (e.key === 'ArrowRight') { scrollTo(current + 1); e.preventDefault(); }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-review-row"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var TONES = ['dawn', 'morning', 'midday', 'golden', 'dusk', 'night'];

    function fill(template, values) {
      return (template || '').replace(/%(\w+)/g, function (match, key) {
        return key in values ? values[key] : match;
      });
    }

    function init(root) {
      if (root.dataset.kbRrBound === 'true') return;
      root.dataset.kbRrBound = 'true';

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var slider = root.querySelector('[data-kb-rr-slider]');
      var track = root.querySelector('[data-kb-rr-cards]');
      var nav = root.querySelector('[data-kb-rr-nav]');
      var prev = root.querySelector('[data-kb-rr-prev]');
      var next = root.querySelector('[data-kb-rr-next]');
      var dial = root.querySelector('[data-kb-rr-dial]');
      var arc = root.querySelector('[data-kb-rr-arc]');
      var sun = root.querySelector('[data-kb-rr-sun]');
      var intro = root.querySelector('[data-kb-rr-intro]');
      var wide = window.matchMedia('(min-width: 900px)');

      var items = Array.prototype.map.call(track.children, function (card) {
        var video = card.querySelector('video');
        if (video && !reduce) video.controls = false;
        return { card: card, shot: card.querySelector('.kb-rr-shot'), video: video, label: card.dataset.label, playing: false };
      });
      var count = items.length;

      // The cover/photo switch works in every mode.
      root.querySelectorAll('.kb-rr-shot__flip').forEach(function (button) {
        button.hidden = false;
        button.addEventListener('click', function () {
          var shot = button.closest('.kb-rr-shot');
          var painted = shot.classList.toggle('is-painted');
          var video = shot.querySelector('video');
          button.setAttribute('aria-pressed', painted ? 'true' : 'false');
          button.textContent = painted ? button.dataset.on : button.dataset.off;
          if (video && !reduce) {
            if (painted) video.pause();
            else { video.currentTime = 0; video.play().catch(function () {}); }
          }
        });
      });

      if (count < 2) return;

      var visible = 1;
      var steps = 1;
      var step = 1;
      var current = -1;
      var stops = [];
      var arcLength = arc.getTotalLength();
      var inView = false;
      var ticking = false;
      var settleTimer = 0;
      var target = null;

      function layout() {
        var isWide = wide.matches;
        var width = track.clientWidth;
        var gutter = isWide ? 32 : 16;
        var gap = isWide ? 28 : 14;
        visible = isWide ? Math.min(3, count) : 1;
        var cardWidth = isWide ? (Math.min(1240, width) - 2 * gutter - 2 * gap) / 3 : Math.min(width * 0.72, 340);
        slider.style.setProperty('--card-w', cardWidth + 'px');
        step = cardWidth + gap;
        steps = Math.max(1, count - visible + 1);
        buildStops();
        update();
      }

      function buildStops() {
        stops.forEach(function (stop) { stop.remove(); });
        stops = [];
        for (var i = 0; i < steps; i++) {
          var stop = document.createElement('button');
          stop.type = 'button';
          stop.className = 'kb-rr__stop';
          stop.setAttribute('aria-label', visible > 1
            ? fill(root.dataset.stepRow, { from: i + 1, to: i + visible, total: count })
            : fill(root.dataset.stepCard, { index: i + 1, total: count, name: items[i].label }));
          stop.addEventListener('click', goTo.bind(null, i));
          var point = arc.getPointAtLength(steps > 1 ? arcLength * i / (steps - 1) : arcLength / 2);
          stop.style.left = (point.x / 320 * 100) + '%';
          stop.style.top = (point.y / 64 * 100) + '%';
          dial.append(stop);
          stops.push(stop);
        }
        current = -1;
      }

      function position() {
        return Math.max(0, Math.min(steps - 1, track.scrollLeft / step));
      }

      // Where the row is heading, so quick repeated arrow presses add up.
      function base() {
        return target === null ? Math.round(position()) : target;
      }

      function goTo(index) {
        index = Math.max(0, Math.min(steps - 1, index));
        target = index;
        track.scrollTo({ left: index * step, behavior: reduce ? 'auto' : 'smooth' });
      }

      // Lazy images in cards still off to the side load late, so the next ones load early.
      function preload(item) {
        if (item.preloaded) return;
        item.preloaded = true;
        item.shot.querySelectorAll('img').forEach(function (img) { img.loading = 'eager'; });
      }

      // Reveal the photo only once it has loaded, so the cover never gives way to an empty frame.
      function develop(item) {
        if (reduce || item.shot.classList.contains('is-developed') || item.pending) return;
        item.pending = true;
        preload(item);
        var photo = item.shot.querySelector('img.kb-rr-shot__photo');
        var ready = photo && !photo.complete
          ? new Promise(function (resolve) {
              photo.addEventListener('load', resolve, { once: true });
              photo.addEventListener('error', resolve, { once: true });
            })
          : Promise.resolve();
        ready.then(function () {
          window.setTimeout(function () {
            item.shot.classList.add('is-developed');
            item.pending = false;
          }, 120);
        });
      }

      // Phones get the lighter clip, like the hero video.
      function loadClip(item) {
        var video = item.video;
        if (!video || video.dataset.kbRrLoaded) return;
        var small = video.dataset.srcSmall;
        if (small && item.card.offsetWidth * (window.devicePixelRatio || 1) <= 1100) video.src = small;
        video.preload = 'auto';
        video.dataset.kbRrLoaded = 'true';
      }

      // How far a card sits outside the cards in view (0 when it is one of them).
      function distance(i, t) {
        var offset = i - t;
        if (offset < 0) return -offset;
        return Math.max(0, offset - (visible - 1));
      }

      function update() {
        ticking = false;
        var t = position();
        items.forEach(function (item, i) {
          var d = Math.min(distance(i, t), 1);
          if (!reduce) {
            item.card.style.setProperty('--s', (visible > 1 ? 1 : 1 - 0.1 * d).toFixed(3));
            item.card.style.setProperty('--o', (1 - 0.3 * d).toFixed(3));
          }
          if (inView) {
            if (distance(i, t) <= 2) preload(item);
            if (distance(i, t) < 1.05) develop(item);
          }
        });

        var index = Math.round(t);
        if (index !== current) {
          current = index;
          stops.forEach(function (stop, i) { stop.setAttribute('aria-current', i === index ? 'true' : 'false'); });
        }
        prev.disabled = t < 0.05;
        next.disabled = t > steps - 1.05;
        var fraction = steps > 1 ? t / (steps - 1) : 0;
        root.dataset.tone = TONES[Math.round(fraction * (TONES.length - 1))];
        var point = arc.getPointAtLength(arcLength * fraction);
        sun.setAttribute('transform', 'translate(' + point.x.toFixed(1) + ' ' + point.y.toFixed(1) + ')');
      }

      // A clip plays once from the start each time its card comes to rest in view.
      function settle() {
        target = null;
        var index = Math.round(position());
        items.forEach(function (item, i) {
          if (!item.video || reduce) return;
          var active = inView && i >= index && i <= index + visible - 1;
          if (active && !item.playing && !item.shot.classList.contains('is-painted')) {
            item.playing = true;
            loadClip(item);
            item.video.currentTime = 0;
            item.video.play().catch(function () {});
          } else if (!active && item.playing) {
            item.playing = false;
            item.video.pause();
          }
        });
      }

      function onScroll() {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
        window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(settle, 160);
      }

      track.addEventListener('scroll', onScroll, { passive: true });
      prev.addEventListener('click', function () { goTo(base() - 1); });
      next.addEventListener('click', function () { goTo(base() + 1); });

      // Tapping a card at the side brings it into view.
      track.addEventListener('click', function (event) {
        if (event.target.closest('a, button')) return;
        var card = event.target.closest('.kb-rr-card');
        if (!card) return;
        var i = items.findIndex(function (item) { return item.card === card; });
        var t = position();
        if (i < Math.round(t)) goTo(i);
        else if (i > Math.round(t) + visible - 1) goTo(i - visible + 1);
      });

      // Mouse users can drag the row; touch and trackpads scroll it natively.
      var drag = null;
      track.addEventListener('dragstart', function (event) { event.preventDefault(); });
      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('a, button')) return;
        drag = { x: event.clientX, left: track.scrollLeft, moved: false };
      });
      window.addEventListener('pointermove', function (event) {
        if (!drag) return;
        var dx = event.clientX - drag.x;
        if (!drag.moved && Math.abs(dx) < 6) return;
        if (!drag.moved) {
          drag.moved = true;
          track.classList.add('is-dragging');
        }
        track.scrollLeft = drag.left - dx;
      });
      window.addEventListener('pointerup', function (event) {
        if (!drag) return;
        var moved = drag.moved;
        var dx = event.clientX - drag.x;
        drag = null;
        if (!moved) return;
        track.classList.remove('is-dragging');
        // A drag is not a click on the card under the pointer.
        track.addEventListener('click', function (e) { e.stopPropagation(); e.preventDefault(); }, { capture: true, once: true });
        goTo(Math.round(position() + (dx < 0 ? 0.3 : -0.3)));
      });

      nav.hidden = false;
      if (!reduce) root.classList.add('is-live');
      if (intro.getBoundingClientRect().top > window.innerHeight) intro.classList.add('is-waiting');
      layout();

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === intro && entry.isIntersecting) intro.classList.remove('is-waiting');
          if (entry.target === slider) {
            inView = entry.isIntersecting;
            if (inView) slider.classList.add('is-in');
            update();
            settle();
          }
        });
      }, { rootMargin: '0px 0px -12% 0px' });
      observer.observe(intro);
      observer.observe(slider);

      var resizeTimer = 0;
      function relayout() {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(layout, 120);
      }
      window.addEventListener('resize', relayout);
      wide.addEventListener('change', relayout);
    }

    // Browsers fetch video posters on sight, so they're attached as the row nears.
    function loadPosters(root) {
      var videos = root.querySelectorAll('video[data-poster]');
      if (!videos.length) return;
      var observer = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        videos.forEach(function (video) { video.poster = video.dataset.poster; });
      }, { rootMargin: '600px 0px' });
      observer.observe(root);
    }

    function setup(root) {
      loadPosters(root);
      init(root);
    }

    document.querySelectorAll('[data-kb-rr]').forEach(setup);
    document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll('[data-kb-rr]').forEach(setup);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReviewSliders(scope) {
      var sliders = scope.querySelectorAll('[data-kb-reviews-slider]');

      sliders.forEach(function (root) {
        if (root.dataset.kbReviewsBound === 'true') return;

        var track = root.querySelector('[data-kb-reviews-track]');
        var slides = root.querySelectorAll('[data-kb-reviews-slide]');
        var controls = root.querySelector('[data-kb-reviews-controls]');
        var prev = root.querySelector('[data-kb-reviews-prev]');
        var next = root.querySelector('[data-kb-reviews-next]');

        if (!track || slides.length <= 1 || !controls || !prev || !next) return;

        root.dataset.kbReviewsBound = 'true';
        root.classList.add('is-initialized');

        var originals = Array.prototype.slice.call(slides);
        var cloneCount = Math.min(3, originals.length);
        var current = 0;
        var visibleCount = 1;
        var physicalIndex = cloneCount;
        var items = [];
        var step = 0;
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var scrollFrame = null;
        var settleTimer = null;

        function makeClone(slide) {
          var clone = slide.cloneNode(true);
          clone.removeAttribute('data-kb-reviews-slide');
          clone.removeAttribute('data-shopify-editor-block');
          clone.removeAttribute('id');
          clone.setAttribute('data-kb-reviews-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.classList.add('kb-animate--visible');
          return clone;
        }

        var before = document.createDocumentFragment();
        originals.slice(-cloneCount).forEach(function (slide) {
          before.appendChild(makeClone(slide));
        });
        track.insertBefore(before, track.firstChild);

        originals.slice(0, cloneCount).forEach(function (slide) {
          track.appendChild(makeClone(slide));
        });

        items = Array.prototype.slice.call(
          track.querySelectorAll('[data-kb-reviews-slide], [data-kb-reviews-clone]')
        );

        function getGap() {
          var styles = window.getComputedStyle(track);
          return parseFloat(styles.columnGap || styles.gap) || 0;
        }

        function logicalIndex(index) {
          return ((index - cloneCount) % originals.length + originals.length) % originals.length;
        }

        function scrollToPhysical(index, behavior) {
          var item = items[index];
          if (!item) return;

          track.scrollTo({
            left: item.offsetLeft - track.offsetLeft,
            behavior: behavior
          });
        }

        function measure() {
          var slideWidth = originals[0].getBoundingClientRect().width;
          step = slideWidth + getGap();
          visibleCount = Math.max(1, Math.round((track.clientWidth + getGap()) / step));
          physicalIndex = cloneCount + current;
          controls.hidden = originals.length <= visibleCount;
          scrollToPhysical(physicalIndex, 'auto');
        }

        function normalizeLoop() {
          if (physicalIndex < cloneCount) {
            physicalIndex += originals.length;
            scrollToPhysical(physicalIndex, 'auto');
          } else if (physicalIndex >= cloneCount + originals.length) {
            physicalIndex -= originals.length;
            scrollToPhysical(physicalIndex, 'auto');
          }

          current = logicalIndex(physicalIndex);
        }

        function moveBy(delta) {
          physicalIndex += delta;
          current = logicalIndex(physicalIndex);
          scrollToPhysical(physicalIndex, reduceMotion ? 'auto' : 'smooth');

          window.clearTimeout(settleTimer);
          settleTimer = window.setTimeout(normalizeLoop, reduceMotion ? 0 : 450);
        }

        function syncFromScroll() {
          if (step <= 0) return;

          physicalIndex = Math.max(
            0,
            Math.min(Math.round(track.scrollLeft / step), items.length - visibleCount)
          );
          current = logicalIndex(physicalIndex);

          window.clearTimeout(settleTimer);
          settleTimer = window.setTimeout(normalizeLoop, 140);
        }

        prev.addEventListener('click', function () {
          moveBy(-1);
        });

        next.addEventListener('click', function () {
          moveBy(1);
        });

        track.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft') {
            moveBy(-1);
            event.preventDefault();
          }

          if (event.key === 'ArrowRight') {
            moveBy(1);
            event.preventDefault();
          }
        });

        track.addEventListener('scroll', function () {
          if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
          scrollFrame = window.requestAnimationFrame(syncFromScroll);
        }, { passive: true });

        window.addEventListener('resize', measure);
        measure();
      });
    }

    initReviewSliders(document);

    document.addEventListener('shopify:section:load', function (event) {
      initReviewSliders(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-shelf"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var mq = window.matchMedia('(min-width: 1024px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var LERP = 0.12;

    function init(section) {
      var track = section.querySelector('[data-shelf-track]');
      if (!track) return;
      var dir = (section.getAttribute('data-shelf-direction') || 'left').toLowerCase();

      var targetX = 0;
      var currentX = 0;
      var overflow = 0;
      var running = false;

      function apply(v) { track.style.setProperty('--kb-track-x', v + 'px'); }
      function reset() {
        section.style.minHeight = '';
        targetX = 0;
        currentX = 0;
        apply(0);
      }

      /* `range` is cached rather than re-read on every scroll: reading
         section.offsetHeight right after measure() writes section.style
         .minHeight forced a synchronous layout each frame. It equals the
         overflow by construction (minHeight = innerHeight + o). */
      var range = 0;

      function measure() {
        if (!mq.matches || reduce.matches) { reset(); range = 0; return 0; }
        var o = Math.max(0, track.scrollWidth - track.clientWidth);
        if (o <= 0) { reset(); range = 0; return 0; }
        section.style.minHeight = (window.innerHeight + o) + 'px';
        range = o;
        return o;
      }

      function readTarget() {
        if (!mq.matches || reduce.matches || overflow <= 0 || range <= 0) { targetX = 0; return; }
        var rect = section.getBoundingClientRect();
        var scrolled = Math.max(0, Math.min(range, -rect.top));
        var progress = scrolled / range;
        // dir 'left'  : cards travel leftward → translate from 0 to -overflow
        // dir 'right' : cards travel rightward → start at -overflow, end at 0
        if (dir === 'right') {
          targetX = -overflow * (1 - progress);
        } else {
          targetX = -overflow * progress;
        }
      }

      function tick() {
        var d = targetX - currentX;
        if (Math.abs(d) < 0.15) {
          currentX = targetX;
          apply(currentX);
          running = false;
          return;
        }
        currentX += d * LERP;
        apply(currentX);
        requestAnimationFrame(tick);
      }

      function kick() {
        readTarget();
        if (!running) { running = true; requestAnimationFrame(tick); }
      }

      function onScroll() { kick(); }
      function onResize() {
        overflow = measure();
        readTarget();
        currentX = targetX;
        apply(currentX);
      }

      overflow = measure();
      readTarget();
      currentX = targetX;
      apply(currentX);

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize);
      mq.addEventListener ? mq.addEventListener('change', onResize) : mq.addListener(onResize);

      var imgs = track.querySelectorAll('img');
      var pending = imgs.length;
      if (pending) {
        for (var i = 0; i < imgs.length; i++) {
          if (imgs[i].complete) { if (--pending === 0) onResize(); }
          else imgs[i].addEventListener('load', function() { if (--pending === 0) onResize(); }, { once: true });
        }
      }
    }

    /* Below-the-fold scroll effect that measures layout on init - deferred
       past first paint so it cannot force a synchronous layout during parse. */
    function start() {
      var sections = document.querySelectorAll('.kb-shelf--pinned');
      for (var i = 0; i < sections.length; i++) init(sections[i]);
    }

    if ('requestIdleCallback' in window) {
      requestIdleCallback(start, { timeout: 2000 });
    } else {
      setTimeout(start, 200);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-start-personalising"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var wraps = document.querySelectorAll('.kb-start-personalising__formats-wrap');
    wraps.forEach(function (wrap) {
      var btn = wrap.querySelector('[data-kb-upload-formats]');
      var popover = wrap.querySelector('[data-kb-upload-popover]');
      var closeBtn = wrap.querySelector('[data-kb-upload-popover-close]');
      if (!btn || !popover) return;

      function open() {
        popover.setAttribute('data-open', 'true');
        btn.setAttribute('aria-expanded', 'true');
      }
      function close() {
        popover.removeAttribute('data-open');
        btn.setAttribute('aria-expanded', 'false');
      }
      function isOpen() {
        return popover.getAttribute('data-open') === 'true';
      }

      // Click / tap toggles (primary path on touch where hover doesn't exist).
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (isOpen()) { close(); } else { open(); }
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          close();
        });
      }

      // Close when clicking outside the wrap.
      document.addEventListener('click', function (e) {
        if (!isOpen()) return;
        if (!wrap.contains(e.target)) close();
      });

      // Escape closes and returns focus to the button.
      wrap.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && isOpen()) {
          close();
          btn.focus();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-story-nudge"]) return;
  try {
    
  (function () {
    var nudge = document.querySelector('[data-kb-story-nudge]');
    if (!nudge) return;

    // Visible seconds this visit (across pages), whether it showed this visit,
    // and until when a closed or followed invitation stays away.
    var SECONDS = 'kb-nudge-seconds';
    var SHOWN = 'kb-nudge-shown';
    var SNOOZE = 'kb-nudge-snooze';
    var delay = Number(nudge.getAttribute('data-delay')) || 60;

    function read(kind, key) {
      try { return Number(window[kind].getItem(key)) || 0; } catch (e) { return 0; }
    }
    function write(kind, key, value) {
      try { window[kind].setItem(key, String(value)); } catch (e) { /* storage blocked: this page only */ }
    }
    if (read('localStorage', SNOOZE) > Date.now() || read('sessionStorage', SHOWN)) return;

    // Not over a photo being personalised, a preview being painted, or the cookie banner.
    function busy() {
      return document.querySelector('[data-kb-step="details"]:not([hidden]), [data-kb-step="status"]:not([hidden]), .kb-cookie-consent:not([hidden])');
    }

    var seconds = read('sessionStorage', SECONDS);
    var timer = window.setInterval(function () {
      if (document.visibilityState !== 'visible') return;
      seconds += 1;
      write('sessionStorage', SECONDS, seconds);
      if (seconds >= delay && !busy()) show();
    }, 1000);

    function onKey(e) {
      if (e.key === 'Escape') close(7);
    }
    function show() {
      window.clearInterval(timer);
      write('sessionStorage', SHOWN, 1);
      // Sits above the product page's sticky bar when it's showing.
      var bar = document.querySelector('.kb-sticky-cta.is-visible');
      if (bar) nudge.style.setProperty('--kb-nudge-lift', bar.offsetHeight + 'px');
      nudge.hidden = false;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { nudge.classList.add('is-in'); });
      });
      document.addEventListener('keydown', onKey);
    }
    function close(days) {
      write('localStorage', SNOOZE, Date.now() + days * 86400000);
      nudge.classList.remove('is-in');
      document.removeEventListener('keydown', onKey);
      window.setTimeout(function () { nudge.hidden = true; }, 600);
    }

    nudge.querySelector('[data-kb-story-nudge-close]').addEventListener('click', function () { close(7); });
    nudge.querySelector('[data-kb-story-nudge-cta]').addEventListener('click', function () { close(30); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-video-reels"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setSoundState(button, on, labels) {
      if (!button) return;
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
      button.setAttribute('aria-label', on ? labels.mute : labels.unmute);
    }

    function initReels(scope, fromEditor) {
      var roots = scope.querySelectorAll('[data-kb-reels]');

      roots.forEach(function (root) {
        if (root.dataset.kbReelsBound === 'true') return;
        root.dataset.kbReelsBound = 'true';

        if (fromEditor) {
          /* The global scroll-reveal observer only runs on first paint, so a
             section re-rendered by the theme editor must reveal itself. */
          root.querySelectorAll('.kb-animate, .kb-stagger > *').forEach(function (el) {
            el.classList.add('kb-animate--visible');
          });
        }

        var track = root.querySelector('[data-kb-reels-track]');
        var slides = Array.prototype.slice.call(root.querySelectorAll('[data-kb-reels-slide]'));
        if (!track || !slides.length) return;

        var prev = root.querySelector('[data-kb-reels-prev]');
        var next = root.querySelector('[data-kb-reels-next]');
        var dots = Array.prototype.slice.call(root.querySelectorAll('[data-kb-reels-dot]'));
        var autoplay = root.dataset.kbReelsPlayback === 'autoplay' && !reduceMotion;
        var labels = {
          play: root.dataset.labelPlay || 'Play video',
          pause: root.dataset.labelPause || 'Pause video',
          mute: root.dataset.labelMute || 'Mute',
          unmute: root.dataset.labelUnmute || 'Unmute'
        };
        var current = 0;
        var scrollFrame = null;
        var videos = [];

        root.classList.add('is-initialized');

        /* ---------- Carousel ---------- */
        function trackInset() {
          return parseFloat(window.getComputedStyle(track).paddingLeft) || 0;
        }

        function goTo(index, behavior) {
          index = Math.max(0, Math.min(index, slides.length - 1));
          track.scrollTo({
            left: slides[index].offsetLeft - trackInset(),
            behavior: behavior || (reduceMotion ? 'auto' : 'smooth')
          });
        }

        function setCurrent(index) {
          current = index;
          dots.forEach(function (dot, i) {
            var active = i === index;
            dot.classList.toggle('is-active', active);
            if (active) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });
        }

        function syncFromScroll() {
          var origin = track.scrollLeft + trackInset();
          var best = 0;
          var bestDist = Infinity;
          slides.forEach(function (slide, i) {
            var dist = Math.abs(slide.offsetLeft - origin);
            if (dist < bestDist) {
              bestDist = dist;
              best = i;
            }
          });
          setCurrent(best);
        }

        function atEnd() {
          return track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        }

        function atStart() {
          return track.scrollLeft <= 2;
        }

        if (prev) {
          prev.addEventListener('click', function () {
            if (atStart()) {
              goTo(slides.length - 1);
            } else {
              goTo(current - 1);
            }
          });
        }

        if (next) {
          next.addEventListener('click', function () {
            if (atEnd()) {
              goTo(0);
            } else {
              goTo(current + 1);
            }
          });
        }

        dots.forEach(function (dot, i) {
          dot.addEventListener('click', function () { goTo(i); });
        });

        track.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft') {
            goTo(current - 1);
            event.preventDefault();
          } else if (event.key === 'ArrowRight') {
            goTo(current + 1);
            event.preventDefault();
          }
        });

        track.addEventListener('scroll', function () {
          if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
          scrollFrame = window.requestAnimationFrame(syncFromScroll);
        }, { passive: true });

        /* ---------- Video playback ---------- */
        function muteOthers(keep) {
          videos.forEach(function (entry) {
            if (entry.video === keep) return;
            entry.video.muted = true;
            setSoundState(entry.sound, false, labels);
          });
        }

        function safePlay(entry) {
          var promise = entry.video.play();
          if (promise && typeof promise.catch === 'function') {
            promise.catch(function () {
              /* Autoplay was blocked - keep the poster + play glyph. */
              entry.slide.classList.remove('is-playing');
            });
          }
        }

        slides.forEach(function (slide) {
          var video = slide.querySelector('[data-kb-reels-video]');
          if (!video) return;

          var entry = {
            slide: slide,
            video: video,
            toggle: slide.querySelector('[data-kb-reels-toggle]'),
            sound: slide.querySelector('[data-kb-reels-sound]')
          };
          videos.push(entry);

          if (autoplay) video.muted = true;

          video.addEventListener('play', function () {
            slide.classList.add('is-playing');
            if (entry.toggle) entry.toggle.setAttribute('aria-label', labels.pause);
          });

          video.addEventListener('pause', function () {
            slide.classList.remove('is-playing');
            if (entry.toggle) entry.toggle.setAttribute('aria-label', labels.play);
          });

          if (entry.toggle) {
            entry.toggle.addEventListener('click', function () {
              if (video.paused) {
                if (!autoplay) {
                  /* Tap-to-play mode: a deliberate tap plays with sound. */
                  muteOthers(video);
                  video.muted = false;
                  setSoundState(entry.sound, true, labels);
                }
                safePlay(entry);
              } else {
                video.pause();
              }
            });
          }

          if (entry.sound) {
            entry.sound.addEventListener('click', function () {
              var turnOn = video.muted;
              if (turnOn) muteOthers(video);
              video.muted = !turnOn;
              setSoundState(entry.sound, turnOn, labels);
              if (turnOn && video.paused) safePlay(entry);
            });
          }

          setSoundState(entry.sound, !video.muted, labels);
        });

        if (autoplay && videos.length && 'IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (observed) {
              var entry = null;
              for (var i = 0; i < videos.length; i++) {
                if (videos[i].video === observed.target) entry = videos[i];
              }
              if (!entry) return;

              if (observed.intersectionRatio >= 0.5) {
                if (entry.video.paused) safePlay(entry);
              } else if (!entry.video.paused) {
                entry.video.pause();
                /* Reels that leave the viewport go back to muted so sound
                   never surprises the visitor when they scroll back. */
                if (!entry.video.muted) {
                  entry.video.muted = true;
                  setSoundState(entry.sound, false, labels);
                }
              }
            });
          }, { threshold: 0.5 });

          videos.forEach(function (entry) { io.observe(entry.video); });
        }

        /* Pause everything when the tab is hidden - saves battery on mobile. */
        document.addEventListener('visibilitychange', function () {
          if (!document.hidden) return;
          videos.forEach(function (entry) {
            if (!entry.video.paused) entry.video.pause();
          });
        });

        /* ---------- Theme editor ---------- */
        root.addEventListener('shopify:block:select', function (event) {
          var index = slides.indexOf(event.target);
          if (index > -1) goTo(index, 'auto');
        });

        syncFromScroll();
      });
    }

    initReels(document, false);

    document.addEventListener('shopify:section:load', function (event) {
      initReels(event.target, true);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
